export default __webpack_public_path__ + "static/media/kangaroo.694ba4dd.png";